import { render, staticRenderFns } from "./StatusColumn.vue?vue&type=template&id=6a47b658"
import script from "./StatusColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusColumn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports